import type { FC } from 'react';
import type { Language } from '@/types/locales';
import { AnimatePresence, motion } from 'motion/react';
import FlagEn from './flags/en.svg?react';
import FlagRu from './flags/ru.svg?react';
import styles from './LanguageSelector.module.css';

type Props = {
    value: Language;
    onChange: (value: Language) => void;
};

export const LanguageSelector: FC<Props> = ({ value, onChange }) => (
    <AnimatePresence mode="wait" initial={false}>
        <motion.button
            key={value}
            variants={{
                hidden: { scale: 0.1 },
                visible: { scale: 1 },
                hover: { scale: 1.1 },
                tap: { scale: 0.9 }
            }}
            whileHover="hover"
            whileTap="tap"
            initial="hidden"
            animate="visible"
            exit="hidden"
            onClick={() => onChange(value === 'en' ? 'ru' : 'en')}
            transition={{ duration: 0.1 }}
            className={styles.container}
        >
            {value === 'en' ? <FlagEn /> : <FlagRu />}
        </motion.button>
    </AnimatePresence>
);
